import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const LancamentoList = props => <DefaultDataTable data={props} />;